/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { RestoreCaseResponseJson } from './restore-case-response-json';
import { RestoreCaseResult } from '../results/restore-case-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class RestoreCaseResponse extends ResponseWithErrorGeneric<RestoreCaseResponseJson, RestoreCaseResult> implements IResponseWithErrorGeneric<RestoreCaseResult> {
  public failedClearanceCaseId: string = undefined;

  //<custom-body>
  constructor(response: HttpResponse<RestoreCaseResponse>) {
    super(response, RestoreCaseResult.Error);
    if (this.result === RestoreCaseResult.InvalidStatus) {
      this.failedClearanceCaseId = this.body.failedClearanceCaseId;
    }
  }
  //</custom-body>
}
